/**
 * Utility functions to manage user 24-hour session validity.
 */

export const SESSION_DURATION_MS = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

/**
 * Sets the session start timestamp in localStorage.
 */
export const setSessionStartTime = (): void => {
    localStorage.setItem('sessionStartTime', Date.now().toString());
};

/**
 * Gets the stored session start timestamp from localStorage.
 */
export const getSessionStartTime = (): number | null => {
    const timeStr = localStorage.getItem('sessionStartTime');
    if (!timeStr) return null;
    const time = parseInt(timeStr, 10);
    return isNaN(time) ? null : time;
};

/**
 * Checks if the current session has exceeded 24 hours.
 */
export const isSessionExpired = (): boolean => {
    const startTime = getSessionStartTime();
    if (!startTime) return false;
    const elapsed = Date.now() - startTime;
    return elapsed >= SESSION_DURATION_MS;
};

/**
 * Clears the session start timestamp from localStorage.
 */
export const clearSessionTime = (): void => {
    localStorage.removeItem('sessionStartTime');
};
